import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Table, Input, Checkbox } from 'antd';
import { getBikeModelVariantsRequest } from '../redux/actions/get_bike_model_variants.actions';
import { changeBikeModelVariantRequest } from '../redux/actions/change_bike_model_variants.actions';
import { history } from '../../../../config/history';
import { getVal } from '../../../../shared/helpers';


class BikeVariantsN extends PureComponent {
    state = {
        show_margins: false,
        show_duplicates: false,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(getBikeModelVariantsRequest(history.location.pathname.slice(-24)));
    }

    handleShowMargins = ({ target: { checked } }) => this.setState({ show_margins: checked });

    handleShowDuplicates = ({ target: { checked } }) => this.setState({ show_duplicates: checked });


    handleChangeVariants = (value, key, variant_id, nested_key) => {
        this.props.dispatch(changeBikeModelVariantRequest(variant_id, key, value, nested_key));
    };

    styles = {
        table_wrapper: {
            padding: '0 10px',
            backgroundColor: '#fff',
        },
        table: {
            cells: { width: '6%' },
        },
        input: {
            width: '100%',
            maxWidth: 80,
        },
    };

    render() {
        const margin_columns = [
            {
                title: 'Margin Q1',
                dataIndex: 'margin_by_quarter.q1',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.margin_by_quarter.q1} onBlur={e => this.handleChangeVariants(e.target.value, 'margin_by_quarter.q1', data._id)} />,
            },
            {
                title: 'Margin Q2',
                dataIndex: 'margin_by_quarter.q2',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.margin_by_quarter.q2} onBlur={e => this.handleChangeVariants(e.target.value, 'margin_by_quarter.q2', data._id)} />,
            },
            {
                title: 'Margin Q3',
                dataIndex: 'margin_by_quarter.q3',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.margin_by_quarter.q3} onBlur={e => this.handleChangeVariants(e.target.value, 'margin_by_quarter.q3', data._id)} />,
            },
            {
                title: 'Margin Q4',
                dataIndex: 'margin_by_quarter.q4',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.margin_by_quarter.q4} onBlur={e => this.handleChangeVariants(e.target.value, 'margin_by_quarter.q4', data._id)} />,
            },
        ];

        const duplicate_columns = [
            // {
            //     title: "Dupe min",
            //     dataIndex: "duplicate_min",
            //     render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.duplicate_min} onBlur={(e) => this.handleChangeVariants(e.target.value, "duplicate_min", data._id)}/>,
            // },
            {
                title: 'Transport arranged',
                align: 'center',
                dataIndex: 'calculated_data.bike_leads_with_transport_arranged',
                render: (v, data) => <span>{getVal(data, 'calculated_data.bike_leads_with_transport_arranged') || 0}</span>,
            },
            {
                title: 'Bikes in stock',
                align: 'center',
                dataIndex: 'calculated_data.bikes_in_stock_is_not_sold',
                render: (v, data) => <span>{getVal(data, 'calculated_data.bikes_in_stock_is_not_sold') || 0}</span>,
            },
            {
                title: 'Dupe max',
                dataIndex: 'duplicate_max',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.duplicate_max} onBlur={e => this.handleChangeVariants(e.target.value, 'duplicate_max', data._id)} />,
            },
            {
                title: 'Dupe margin',
                dataIndex: 'duplicate_margin',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.duplicate_margin} onBlur={e => this.handleChangeVariants(e.target.value, 'duplicate_margin', data._id)} />,
            },
            {
                title: 'Dupe wanted',
                dataIndex: 'duplicate_stock_wanted',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.duplicate_stock_wanted} onBlur={e => this.handleChangeVariants(e.target.value, 'duplicate_stock_wanted', data._id)} />,
            },
        ];

        const columns = [
            {
                title: 'Year',
                dataIndex: 'year',
            },
            {
                title: 'Stock Limit',
                dataIndex: 'stock_limit',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.stock_limit} onBlur={e => this.handleChangeVariants(e.target.value, 'stock_limit', data._id)} />,
            },
            {
                title: 'Min Price',
                dataIndex: 'guide_price.min_price',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.guide_price.min_price} onBlur={e => this.handleChangeVariants(e.target.value, 'guide_price.min_price', data._id)} />,
            },
            {
                title: 'Max Price',
                dataIndex: 'guide_price.max_price',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.guide_price.max_price} onBlur={e => this.handleChangeVariants(e.target.value, 'guide_price.max_price', data._id)} />,
            },
            {
                title: 'Hot list',
                align: 'center',
                dataIndex: 'is_hot',
                render: (v, data) => <Checkbox checked={data.is_hot} onChange={e => this.handleChangeVariants(e.target.checked, 'is_hot', data._id)} />,
            },
            {
                title: 'Hot margin',
                dataIndex: 'hot_margin',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.hot_margin} onBlur={e => this.handleChangeVariants(e.target.value, 'hot_margin', data._id)} />,
            },
            {
                title: 'Cold list',
                align: 'center',
                dataIndex: 'is_no_buy',
                render: (v, data) => <Checkbox checked={data.is_no_buy} onChange={e => this.handleChangeVariants(e.target.checked, 'is_no_buy', data._id)} />,
            },
            {
                title: 'Cold margin',
                dataIndex: 'cold_margin',
                render: (v, data) => <Input style={this.styles.input} size="small" type="number" defaultValue={data.cold_margin} onBlur={e => this.handleChangeVariants(e.target.value, 'cold_margin', data._id)} />,
            },
        ];

        if (this.state.show_margins) {
            columns.splice(1, 0, ...margin_columns);
        }

        if (this.state.show_duplicates) {
            columns.splice(1, 0, ...duplicate_columns);
        }


        return (
            <div style={this.styles.table_wrapper} className="border-shadows">
                <Checkbox style={{ margin: '10px 0 10px 15px' }} checked={this.state.show_margins} onChange={this.handleShowMargins}>Show Margins</Checkbox>
                <Checkbox style={{ margin: '10px 0 10px 15px' }} checked={this.state.show_duplicates} onChange={this.handleShowDuplicates}>Show Duplicates</Checkbox>

                <Table size="small" pagination={{ pageSize: 10 }} dataSource={this.props.variants} rowKey="_id" columns={columns} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    variants: state.PlatformManagement.Bike_management.variants,
    loading: state.PlatformManagement.Bike_management.loading,
});


export default connect(mapStateToProps, null)(BikeVariantsN);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/components/BikeVariantsN.js